<!-- eslint-disable max-lines -->
<template>
  <div :class="['widget', {'border-error': error}]">
    <v-container style="height: 100%;">
      <v-layout>
        <span class="subheading">Message statistics</span>
      </v-layout>

      <template v-if="loading">
        <v-layout
          align-center
          justify-center
          fill-height>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else>
        <v-container style="padding: 12px 24px 0 24px;">
          <table style="table-layout: fixed; width: 100%;">
            <tr>
              <td/>
              <td class="text-xs-center grey--text">Weekly average</td>
              <td class="text-xs-center grey--text">Monthly average</td>
            </tr>
            <tr>
              <td>Messages</td>
              <td class="text-xs-right">
                {{ (new Number(stats.messages.week)).toLocaleString() }} per day
              </td>
              <td class="text-xs-right">
                {{ (new Number(stats.messages.month)).toLocaleString() }}
                per day
              </td>
            </tr>
            <tr>
              <td>Devices</td>
              <td class="text-xs-right">
                {{ (new Number(stats.unique.week)).toLocaleString() }} per day
              </td>
              <td class="text-xs-right">
                {{ (new Number(stats.unique.month)).toLocaleString() }} per day
              </td>
            </tr>
            <tr>
              <td>Orphans</td>
              <td class="text-xs-right">
                {{ (new Number(stats.orphan.week)).toLocaleString() }} per day
              </td>
              <td class="text-xs-right">
                {{ (new Number(stats.orphan.month)).toLocaleString() }} per day
              </td>
            </tr>
          </table>
        </v-container>
      </template>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "messages",
  data () {
    return {
      error: false,
      stats: {
        messages: {},
        orphan: {},
        unique: {}
      },
      loading: false
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}/messages`).
      then((r) => this.stats = r.data).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Messages.vue